module.exports = __webpack_public_path__ + "img/corneliastahl.7c41b2a7.jpg";